import { render, staticRenderFns } from "./CurrencyModalForm.vue?vue&type=template&id=f71ad5a2"
import script from "./CurrencyModalForm.vue?vue&type=script&lang=js"
export * from "./CurrencyModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports